import { Button, Modal } from "react-bootstrap";
import "./share-candidate.modal.scss"
import { Candidate } from "../model/candidate.model";
import { Divider } from "@mui/material";
import { JobPosition } from "../model/report.modelt";
import { useContext, useEffect, useRef, useState } from "react";
import { buildInterviewCandidateInviteLink } from "../utils/interview-invite-link";
import { QuestionsSummaryModel } from "../model/questions-summary.model";
import COPY_ICON from "../assets/images/copy-icon.png";
import { QRCode } from 'react-qrcode-logo';
import { ProviderContext } from "../contexts/provider.context";
import ProfileSCModel from "../model/profile.model";
import tokenService from "../services/token.service";
import DOWNLOAD_ICON from "../assets/images/download-icon.png";
import SHARE_ICON from "../assets/images/share.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
interface ShareCandidateProps {
    isOpen: boolean,
    onClose(candidate): void,
    interview: QuestionsSummaryModel,
    candidate: Candidate,
    job_position: JobPosition,
    period: string
}
const ShareCandidateModal: React.FC<ShareCandidateProps> = ({ isOpen, onClose, candidate, job_position, period, interview }) => {
    const [isMoreDetail, setIsMoreDetail] = useState(false);
    const { profileModel }: any = useContext(ProviderContext);
    const [profileMod, setProfileMod] = useState<ProfileSCModel>(profileModel);
    const url = buildInterviewCandidateInviteLink(interview.job_question_id, candidate.candidate_id);
    const logoCompany = profileMod.companyManageResponses.filter((item) => item.companyUuid == tokenService.getHR9CompanyUUID())[0].companyLogoImageUrl;

    const formatInviteOpened = (iso: string | null | undefined) => {
        if (!iso) return null;
        const d = new Date(iso);
        return Number.isFinite(d.getTime())
            ? d.toLocaleString("th-TH", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
              })
            : null;
    };
    const firstOpened = formatInviteOpened(candidate.invite_email_link_first_opened_at);
    const lastOpened = formatInviteOpened(candidate.invite_email_link_last_opened_at);

    const handleMoredetail = () => {
        setIsMoreDetail(!isMoreDetail);
    }

   
    const sharePage = async () => {
        const title = document.title;
        const text = 'Check this out!';

        if (navigator.share) {
            // ✅ Native mobile/tablet share
            try {
                await navigator.share({ title, text, url });
                console.log('Shared successfully');
            } catch (error) {
                console.error('Sharing failed:', error);
            }
        } else {
            // 🔁 Fallback: copy to clipboard
            try {
                await navigator.clipboard.writeText(url);
                alert('Link copied to clipboard!');
            } catch (err) {
                console.error('Copy failed: ', err);
                window.prompt('Copy this link manually:', url);
            }
        }
    };

    const CopyUrlButton = async () => {
        try {
            await navigator.clipboard.writeText(url);
            alert('URL copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy URL:', err);
            window.prompt('Copy this link manually:', url);
        }
    };

    const downloadCode = () => {
        const canvas: any = document.getElementById("qr");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl
            downloadLink.download = `qr-code-${candidate.firstname}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }
    return (
        <>
            <Modal show={isOpen} onHide={() => onClose(candidate)} className="share-candidate-control">
                <Modal.Body className="share-candidate-body">
                    <FontAwesomeIcon icon={faClose} className="share-close" onClick={onClose}></FontAwesomeIcon>
                    <h4 className="title">รายละเอียดลิงก์การสัมภาษณ์</h4>
                    <div className="section-control">
                        <div className="topic-control">
                            <div className="icon"></div>
                            <span className="text">ข้อมูลผู้สมัคร</span>
                        </div>
                        <span className="share-text-bold">{candidate.firstname} {candidate.lastname}</span>
                        <div className="share-grid-2-control">
                            <div className="share-grid-item">
                                <span className="share-text-regular">อีเมล:</span>
                                <span className="share-text-bold">{candidate.email ? candidate.email : '-'}</span>
                            </div>
                            <div className="share-grid-item">
                                <span className="share-text-regular">เบอร์โทร:</span>
                                <span className="share-text-bold">{candidate.phone ? candidate.phone : '-'}</span>
                            </div>
                            <div className="share-grid-item">
                                <span className="share-text-regular">ตำแหน่งงานปัจจุบัน:</span>
                                <span className="share-text-bold">{candidate.jobTitle ? candidate.jobTitle : '-'}</span>
                            </div>
                            <div className="share-grid-item">
                                <span className="share-text-regular">ประสบการณ์ทั้งหมด:</span>
                                <span className="share-text-bold">{candidate.jobExp ? candidate.jobExp + " ปี" : '-'}</span>
                            </div>
                        </div>
                        <Divider className="share-divider"></Divider>
                    </div>

                    <div className="section-control">
                        <div className="topic-control">
                            <div className="icon"></div>
                            <span className="text">สถานะลิงก์จากอีเมล</span>
                        </div>
                        <div className="share-grid-2-control">
                            <div className="share-grid-item" style={{ gridColumn: "1 / -1" }}>
                                <span className="share-text-regular">เปิดจากอีเมล:</span>
                                <span className="share-text-bold">
                                    {firstOpened
                                        ? `เปิดแล้ว (ครั้งแรก ${firstOpened})`
                                        : "ยังไม่มีการเปิดลิงก์เชิญ (หรือยังไม่โหลดหน้าสัมภาษณ์จากลิงก์)"}
                                </span>
                            </div>
                            {lastOpened && firstOpened !== lastOpened ? (
                                <div className="share-grid-item" style={{ gridColumn: "1 / -1" }}>
                                    <span className="share-text-regular">เปิดล่าสุด:</span>
                                    <span className="share-text-bold">{lastOpened}</span>
                                </div>
                            ) : null}
                        </div>
                        <Divider className="share-divider"></Divider>
                    </div>

                    <div className="section-control">
                        <div className="topic-control">
                            <div className="icon"></div>
                            <span className="text">ข้อมูลการสัมภาษณ์</span>
                        </div>
                        <span className="share-interview-job">{job_position.job_title}</span>
                        <div className="share-flex-column-control">

                            <div className="share-grid-item">
                                <span className="share-text-regular">ประสบการณ์ทั้งหมด:</span>
                                <span className="share-text-bold">{job_position.job_exp ? job_position.job_exp : '-'} ...  <span className="more-detail-link" onClick={handleMoredetail}>{isMoreDetail ? "ย่อ" : "ดูรายละเอียดการสัมภาษณ์เพิ่มเติม"}</span></span>
                            </div>
                        </div>

                        {
                            isMoreDetail &&
                            <>
                                <div className="share-flex-column-control">
                                    <div className="d-flex flex-column">
                                        <span className="share-text-regular">ทักษะที่ต้องการ: </span>
                                        <div className="share-skills-control">
                                            <span className="share-skills-title">Hard Skill:</span>
                                            <div className="tag-control">
                                                {
                                                    job_position.job_advance.hard_skills && job_position.job_advance.hard_skills.length > 0 ?
                                                        job_position.job_advance.hard_skills.map((item, index) => {

                                                            return (
                                                                <div className="tag-item" key={index}>
                                                                    {item}
                                                                </div>
                                                            )
                                                        }) : <></>
                                                }
                                            </div>
                                        </div>
                                        <div className="share-skills-control">
                                            <span className="share-skills-title">Soft Skill:</span>
                                            <div className="tag-control">
                                                {
                                                    job_position.job_advance.soft_skills && job_position.job_advance.soft_skills.length > 0 ?
                                                        job_position.job_advance.soft_skills.map((item, index) => {

                                                            return (
                                                                <div className="tag-item"  key={index}>
                                                                    {item}
                                                                </div>
                                                            )
                                                        }) : <></>
                                                }
                                            </div>
                                        </div>
                                        {
                                            job_position.job_advance.company_culture && job_position.job_advance.company_culture.length > 0 &&

                                            <div className="share-skills-control">
                                                <div className="share-expand-topic-control">
                                                    <span className="text">Company Culture:</span>
                                                </div>

                                                <div className="share-expand-control">
                                                    <div className="tag-control">

                                                        {job_position.job_advance.company_culture.map((item, index) => {

                                                            return (
                                                                <div className="tag-item"  key={index}>
                                                                    {item}
                                                                </div>
                                                            )
                                                        })
                                                        }

                                                    </div>
                                                </div>

                                            </div>
                                        }

                                        {
                                            job_position.job_advance.tool_and_technology && job_position.job_advance.tool_and_technology.length > 0 &&

                                            <div className="share-skills-control">
                                                <div className="share-expand-topic-control">
                                                    <span className="text">Tools and Technology:</span>
                                                </div>

                                                <div className="share-expand-control">
                                                    <div className="tag-control">

                                                        {job_position.job_advance.tool_and_technology.map((item, index) => {

                                                            return (
                                                                <div className="tag-item"  key={index}>
                                                                    {item}
                                                                </div>
                                                            )
                                                        })
                                                        }

                                                    </div>
                                                </div>

                                            </div>
                                        }

                                        {
                                            job_position.job_advance.leadership_expectation && job_position.job_advance.leadership_expectation.length > 0 &&

                                            <div className="share-skills-control">
                                                <div className="share-expand-topic-control">
                                                    <span className="text">Leadership:</span>
                                                </div>

                                                <div className="share-expand-control">
                                                    <div className="tag-control">

                                                        {job_position.job_advance.leadership_expectation.map((item, index) => {

                                                            return (
                                                                <div className="tag-item"  key={index}>
                                                                    {item}
                                                                </div>
                                                            )
                                                        })
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>

                                </div>
                                <Divider className="share-divider"></Divider>


                            </>
                        }

                    </div>
                    <div className="section-control">
                        <div className="topic-control">
                            <div className="icon"></div>
                            <span className="text">ข้อมูลวันสัมภาษณ์</span>
                        </div>
                        <div className="share-period-date">
                            <span className="share-text-regular">ช่วงเวลาสัมภาษณ์:</span>
                            <span className="share-text-bold">{period}</span>
                        </div>
                        <Divider className="share-divider"></Divider>
                    </div>
                    <div className="section-control">
                        <div className="topic-control">
                            <div className="icon"></div>
                            <span className="text">ลิงก์สัมภาษณ์งาน</span>
                        </div>
                        <div className="share-section-control">
                            <div className="d-flex flex-column">
                                <div className="share-interview-link-control">
                                    <span className="share-interview-link">
                                        {url}
                                    </span>
                                    <div className="copy-control" onClick={CopyUrlButton}><img src={COPY_ICON} className="icon"></img><span className="text">คัดลองลิงก์</span></div>
                                </div>

                                <div className="share-link-control" onClick={sharePage}>
                                    <img src={SHARE_ICON} className="icon"></img>
                                    <span className="text">แชร์</span>
                                </div>
                            </div>

                            <div className="share-interview-logo-control">
                                <div className="qr-code-control">
                                    {
                                        logoCompany && 
                                        <QRCode value={url}
                                        logoHeight={40}
                                        logoWidth={40}
                                        size={150}
                                        logoOpacity={1}
                                        enableCORS={true}       // enabling CORS, this is the thing that will bypass that DOM check
                                        qrStyle="dots"          // type of qr code, wether you want dotted ones or the square ones
                                        eyeRadius={10}
                                        id="qr"
                                        logoImage={logoCompany} />
                                    }
                                    
                                </div>

                                <div className="download-text" onClick={downloadCode}>
                                    <img src={DOWNLOAD_ICON} className="icon"></img>
                                    <span className="text">ดาวน์โหลด QR</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>


    )
}

export default ShareCandidateModal;